export default [
    {
        path: 'procedimento',
        component: () => import(/* webpackChunkName: 'raas-procedimento' */ '@/views/raas/procedimento/Index'),
        redirect: 'procedimento/index',
        children: [
            {
                name: 'raas-procedimento-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'raas-procedimento' */ '@/views/raas/procedimento/List.vue'),
            },
            {
                name: 'raas-procedimento-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'raas-procedimento' */ '@/views/raas/procedimento/Form.vue'),
            },
        ],
    },
]